<template>
  <Layout>
    <Content class="buy-license" size="small">
      <Steps :current="currentStep">
        <Step :title="$t('license.courses')" :content="$t('license.coursesContent')" />
        <Step :title="$t('license.paymentInfo')" :content="$t('license.paymentInfoContent')" />
        <Step :title="$t('license.license')" :content="$t('license.licenseContent')" />
      </Steps>

      <Alert show-icon class="institutions" v-if="currentStep !== 2">
        {{$t('license.contactForVolumePricing')}} <a href="mailto:post@leaplearning.no">post@leaplearning.no</a>.
      </Alert>

      <div class="steps steps-1" v-show="currentStep == 0">
        <!-- <Alert show-icon v-show="form.type === 'institution'">
            {{$t('license.introductoryOffer')}}
            <Icon type="ios-thumbs-up" slot="icon"></Icon>
            <template slot="desc">{{$t('license.introductoryOfferText')}}</template>
        </Alert> -->
        <CourseCard v-for="course in sortedCourses.filter(c => c.pricing[form.entity].year !== 0)" :key="course.code"
          :course="course" :entity="form.entity" :period="form.period" :active="course.active === undefined || course.active"
          :vat="vat" :checked="!!selectedCourses.find(c => c.code === course.code)"
          @change="selectCourse($event, course)"
          @term-change="courses = courses.map(c => {c.term = $event; return c})"
          @period-change="form.period = $event"
          @students-change="course.numStudents = $event" />

        <Button size="large" type="primary" class="next-button" @click="nextStep">
          {{$t('next')}}
          <Icon type="ios-arrow-forward" />
        </Button>
      </div>
      <div class="steps steps-2" v-show="currentStep == 1">
        <Form ref="form" :model="form" :rules="formRules" :label-width="98">
          <FormItem :label="$t(form.type === 'institution' ? 'license.form.label.contact':'license.form.label.name')" prop="name">
            <Input v-model="form.name" :placeholder="$t('license.form.placeholder.name')" />
          </FormItem>
          <FormItem :label="$t('license.form.label.email')" prop="email">
            <Input v-model="form.email" :placeholder="$t('license.form.placeholder.email')" />
          </FormItem>
          <FormItem :label="$t('license.form.label.address')" prop="address">
            <Input v-model="form.address" :placeholder="$t('license.form.placeholder.address')" />
          </FormItem>
          <FormItem :label="$t('license.form.label.city')">
            <Row>
              <i-Col span="16">
                <FormItem prop="city">
                  <Input v-model="form.city" :placeholder="$t('license.form.placeholder.city')" />
                </FormItem>
              </i-Col>
              <i-Col span="1">&nbsp;</i-Col>
              <i-Col span="7">
                <FormItem prop="zip">
                  <Input v-model="form.zip" :placeholder="$t('license.form.placeholder.zip')" />
                </FormItem>
              </i-Col>
            </Row>
          </FormItem>
          <FormItem :label="$t('license.form.label.country')" prop="country">
            <Select v-model="form.country" filterable not-found-text="No match" :placeholder="$t('license.form.placeholder.country')">
              <Option value="AF">Afghanistan</Option>
              <Option value="AL">Albania</Option>
              <Option value="DZ">Algeria</Option>
              <Option value="AS">American Samoa</Option>
              <Option value="AD">Andorra</Option>
              <Option value="AO">Angola</Option>
              <Option value="AI">Anguilla</Option>
              <Option value="AQ">Antarctica</Option>
              <Option value="AG">Antigua and Barbuda</Option>
              <Option value="AR">Argentina</Option>
              <Option value="AM">Armenia</Option>
              <Option value="AW">Aruba</Option>
              <Option value="AU">Australia</Option>
              <Option value="AT">Austria</Option>
              <Option value="AZ">Azerbaijan</Option>
              <Option value="BS">Bahamas</Option>
              <Option value="BH">Bahrain</Option>
              <Option value="BD">Bangladesh</Option>
              <Option value="BB">Barbados</Option>
              <Option value="BY">Belarus</Option>
              <Option value="BE">Belgium</Option>
              <Option value="BZ">Belize</Option>
              <Option value="BJ">Benin</Option>
              <Option value="BM">Bermuda</Option>
              <Option value="BT">Bhutan</Option>
              <Option value="BO">Bolivia</Option>
              <Option value="BQ">Bonaire</Option>
              <Option value="BA">Bosnia and Herzegovina</Option>
              <Option value="BW">Botswana</Option>
              <Option value="BV">Bouvet Island</Option>
              <Option value="BR">Brazil</Option>
              <Option value="IO">British Indian Ocean Territory</Option>
              <Option value="BN">Brunei Darussalam</Option>
              <Option value="BG">Bulgaria</Option>
              <Option value="BF">Burkina Faso</Option>
              <Option value="BI">Burundi</Option>
              <Option value="KH">Cambodia</Option>
              <Option value="CM">Cameroon</Option>
              <Option value="CA">Canada</Option>
              <Option value="CV">Cape Verde</Option>
              <Option value="KY">Cayman Islands</Option>
              <Option value="CF">Central African Republic</Option>
              <Option value="TD">Chad</Option>
              <Option value="CL">Chile</Option>
              <Option value="CN">China</Option>
              <Option value="CX">Christmas Island</Option>
              <Option value="CC">Cocos (Keeling) Islands</Option>
              <Option value="CO">Colombia</Option>
              <Option value="KM">Comoros</Option>
              <Option value="CG">Congo</Option>
              <Option value="CD">Democratic Republic of the Congo</Option>
              <Option value="CK">Cook Islands</Option>
              <Option value="CR">Costa Rica</Option>
              <Option value="HR">Croatia</Option>
              <Option value="CU">Cuba</Option>
              <Option value="CW">Curacao</Option>
              <Option value="CY">Cyprus</Option>
              <Option value="CZ">Czech Republic</Option>
              <Option value="CI">Cote d'Ivoire</Option>
              <Option value="DK">Denmark</Option>
              <Option value="DJ">Djibouti</Option>
              <Option value="DM">Dominica</Option>
              <Option value="DO">Dominican Republic</Option>
              <Option value="EC">Ecuador</Option>
              <Option value="EG">Egypt</Option>
              <Option value="SV">El Salvador</Option>
              <Option value="GQ">Equatorial Guinea</Option>
              <Option value="ER">Eritrea</Option>
              <Option value="EE">Estonia</Option>
              <Option value="ET">Ethiopia</Option>
              <Option value="FK">Falkland Islands</Option>
              <Option value="FO">Faroe Islands</Option>
              <Option value="FJ">Fiji</Option>
              <Option value="FI">Finland</Option>
              <Option value="FR">France</Option>
              <Option value="GF">French Guiana</Option>
              <Option value="PF">French Polynesia</Option>
              <Option value="GA">Gabon</Option>
              <Option value="GM">Gambia</Option>
              <Option value="GE">Georgia</Option>
              <Option value="DE">Germany</Option>
              <Option value="GH">Ghana</Option>
              <Option value="GI">Gibraltar</Option>
              <Option value="GR">Greece</Option>
              <Option value="GL">Greenland</Option>
              <Option value="GD">Grenada</Option>
              <Option value="GP">Guadeloupe</Option>
              <Option value="GU">Guam</Option>
              <Option value="GT">Guatemala</Option>
              <Option value="GG">Guernsey</Option>
              <Option value="GN">Guinea</Option>
              <Option value="GW">Guinea-Bissau</Option>
              <Option value="GY">Guyana</Option>
              <Option value="HT">Haiti</Option>
              <Option value="HM">Heard Island and McDonald Islands</Option>
              <Option value="VA">Vatican</Option>
              <Option value="HN">Honduras</Option>
              <Option value="HK">Hong Kong</Option>
              <Option value="HU">Hungary</Option>
              <Option value="IS">Iceland</Option>
              <Option value="IN">India</Option>
              <Option value="ID">Indonesia</Option>
              <Option value="IR">Iran</Option>
              <Option value="IQ">Iraq</Option>
              <Option value="IE">Ireland</Option>
              <Option value="IM">Isle of Man</Option>
              <Option value="IL">Israel</Option>
              <Option value="IT">Italy</Option>
              <Option value="JM">Jamaica</Option>
              <Option value="JP">Japan</Option>
              <Option value="JE">Jersey</Option>
              <Option value="JO">Jordan</Option>
              <Option value="KZ">Kazakhstan</Option>
              <Option value="KE">Kenya</Option>
              <Option value="KI">Kiribati</Option>
              <Option value="KR">Korea, Republic of</Option>
              <Option value="KW">Kuwait</Option>
              <Option value="KG">Kyrgyzstan</Option>
              <Option value="LA">Lao</Option>
              <Option value="LV">Latvia</Option>
              <Option value="LB">Lebanon</Option>
              <Option value="LS">Lesotho</Option>
              <Option value="LR">Liberia</Option>
              <Option value="LY">Libya</Option>
              <Option value="LI">Liechtenstein</Option>
              <Option value="LT">Lithuania</Option>
              <Option value="LU">Luxembourg</Option>
              <Option value="MO">Macao</Option>
              <Option value="MK">Macedonia</Option>
              <Option value="MG">Madagascar</Option>
              <Option value="MW">Malawi</Option>
              <Option value="MY">Malaysia</Option>
              <Option value="MV">Maldives</Option>
              <Option value="ML">Mali</Option>
              <Option value="MT">Malta</Option>
              <Option value="MH">Marshall Islands</Option>
              <Option value="MQ">Martinique</Option>
              <Option value="MR">Mauritania</Option>
              <Option value="MU">Mauritius</Option>
              <Option value="YT">Mayotte</Option>
              <Option value="MX">Mexico</Option>
              <Option value="FM">Micronesia</Option>
              <Option value="MD">Moldova, Republic of</Option>
              <Option value="MC">Monaco</Option>
              <Option value="MN">Mongolia</Option>
              <Option value="ME">Montenegro</Option>
              <Option value="MS">Montserrat</Option>
              <Option value="MA">Morocco</Option>
              <Option value="MZ">Mozambique</Option>
              <Option value="MM">Myanmar</Option>
              <Option value="NA">Namibia</Option>
              <Option value="NR">Nauru</Option>
              <Option value="NP">Nepal</Option>
              <Option value="NL">Netherlands</Option>
              <Option value="NC">New Caledonia</Option>
              <Option value="NZ">New Zealand</Option>
              <Option value="NI">Nicaragua</Option>
              <Option value="NE">Niger</Option>
              <Option value="NG">Nigeria</Option>
              <Option value="NU">Niue</Option>
              <Option value="NF">Norfolk Island</Option>
              <Option value="MP">Northern Mariana Islands</Option>
              <Option value="NO">Norway</Option>
              <Option value="OM">Oman</Option>
              <Option value="PK">Pakistan</Option>
              <Option value="PW">Palau</Option>
              <Option value="PS">Palestine, State of</Option>
              <Option value="PA">Panama</Option>
              <Option value="PG">Papua New Guinea</Option>
              <Option value="PY">Paraguay</Option>
              <Option value="PE">Peru</Option>
              <Option value="PH">Philippines</Option>
              <Option value="PN">Pitcairn</Option>
              <Option value="PL">Poland</Option>
              <Option value="PT">Portugal</Option>
              <Option value="PR">Puerto Rico</Option>
              <Option value="QA">Qatar</Option>
              <Option value="RO">Romania</Option>
              <Option value="RU">Russian Federation</Option>
              <Option value="RW">Rwanda</Option>
              <Option value="RE">Reunion</Option>
              <Option value="BL">Saint Barthelemy</Option>
              <Option value="SH">Saint Helena</Option>
              <Option value="KN">Saint Kitts and Nevis</Option>
              <Option value="LC">Saint Lucia</Option>
              <Option value="MF">Saint Martin</Option>
              <Option value="PM">Saint Pierre and Miquelon</Option>
              <Option value="VC">Saint Vincent and the Grenadines</Option>
              <Option value="WS">Samoa</Option>
              <Option value="SM">San Marino</Option>
              <Option value="ST">Sao Tome and Principe</Option>
              <Option value="SA">Saudi Arabia</Option>
              <Option value="SN">Senegal</Option>
              <Option value="RS">Serbia</Option>
              <Option value="SC">Seychelles</Option>
              <Option value="SL">Sierra Leone</Option>
              <Option value="SG">Singapore</Option>
              <Option value="SX">Sint Maarten</Option>
              <Option value="SK">Slovakia</Option>
              <Option value="SI">Slovenia</Option>
              <Option value="SB">Solomon Islands</Option>
              <Option value="SO">Somalia</Option>
              <Option value="ZA">South Africa</Option>
              <Option value="GS">South Georgia Islands</Option>
              <Option value="SS">South Sudan</Option>
              <Option value="ES">Spain</Option>
              <Option value="LK">Sri Lanka</Option>
              <Option value="SD">Sudan</Option>
              <Option value="SR">Suriname</Option>
              <Option value="SJ">Svalbard and Jan Mayen</Option>
              <Option value="SZ">Swaziland</Option>
              <Option value="SE">Sweden</Option>
              <Option value="CH">Switzerland</Option>
              <Option value="SY">Syria</Option>
              <Option value="TW">Taiwan</Option>
              <Option value="TJ">Tajikistan</Option>
              <Option value="TZ">Tanzania</Option>
              <Option value="TH">Thailand</Option>
              <Option value="TL">Timor-Leste</Option>
              <Option value="TG">Togo</Option>
              <Option value="TK">Tokelau</Option>
              <Option value="TO">Tonga</Option>
              <Option value="TT">Trinidad and Tobago</Option>
              <Option value="TN">Tunisia</Option>
              <Option value="TR">Turkey</Option>
              <Option value="TM">Turkmenistan</Option>
              <Option value="TC">Turks and Caicos Islands</Option>
              <Option value="TV">Tuvalu</Option>
              <Option value="UG">Uganda</Option>
              <Option value="UA">Ukraine</Option>
              <Option value="AE">UAE</Option>
              <Option value="GB">United Kingdom</Option>
              <Option value="US">United States</Option>
              <Option value="UY">Uruguay</Option>
              <Option value="UZ">Uzbekistan</Option>
              <Option value="VU">Vanuatu</Option>
              <Option value="VE">Venezuela</Option>
              <Option value="VN">Viet Nam</Option>
              <Option value="WF">Wallis and Futuna</Option>
              <Option value="EH">Western Sahara</Option>
              <Option value="YE">Yemen</Option>
              <Option value="ZM">Zambia</Option>
              <Option value="ZW">Zimbabwe</Option>
            </Select>
          </FormItem>
          <Divider v-show="form.type === 'individual'" />
          <!-- <FormItem :label="$t('license.form.label.autoRenew')" :label-width="335" prop="autoRenew" v-show="form.type === 'individual'">
            <RadioGroup v-model="form.autoRenew">
              <Radio label="true">{{$t('license.form.label.yes')}}</Radio>
              <Radio label="false">{{$t('license.form.label.no')}}</Radio>
            </RadioGroup>
          </FormItem> -->
        </Form>

        <div class="errors" v-show="formError">{{formError}}</div>

        <Checkbox v-model="form.accepted" v-show="form.type === 'individual'">
          {{$t('license.form.acceptTerms1')}} <a target="_blank" :href="$t('license.form.termsLink')">{{$t('license.form.acceptTerms')}}</a> {{$t('license.form.acceptTerms2')}}
        </Checkbox>

        <Button size="large" type="primary" class="prev-button" @click="prevStep">
          <Icon type="ios-arrow-back" />
          {{$t('back')}}
        </Button>
        <Button size="large" type="primary" class="next-button" :disabled="posting || (form.type === 'individual' && !form.accepted)" @click="submitForm">
          <template v-if="form.type === 'individual'">{{$t('accept')}} </template>
          <template v-else>{{$t('license.askForInvoice')}} </template>
          <Icon type="md-checkmark" />
        </Button>
      </div>

      <div class="steps steps-3" v-if="currentStep == 2 && !purchasingError">
        <img :src="require('@/assets/icons/checkmark.svg')">
        <h2>{{$t('license.payment.succeed')}}</h2>
        <p>{{$t('license.payment.receiptSent')}}<br>{{$t('license.payment.checkSpam')}}</p>
        <br />
        <p>{{$t('license.payment.youHaveAccess')}}</p>
        <br />
        <ul style="list-style: none;">
            <li v-for="course in licensedCourses" :key="course.product" v-html="course.name"></li>
        </ul>
        <h2>{{$t('license.payment.yourLicenseIs')}}</h2>
          <b>{{$t('license.form.label.email')}}:</b> {{licenseEmail}}<br>
          <b>{{$t('license.license')}}:</b> {{licenseNumber}}
        <div style="margin-top: 25px">{{$t('license.payment.alsoSentToEmail')}}</div>
        <div class="download-buttons">
          <a target="_blank" href="https://webapps.leaplearning.no">
            <Button>{{$t('license.payment.gotoWebapps')}}</Button>
          </a>
          <a target="_blank" href="https://play.google.com/store/apps/details?id=no.leaplearning.launcher" class="android-button"></a>
          <a target="_blank" href="https://apps.apple.com/no/app/leap-learnings-app-universe/id1489716738" class="ios-button"></a>
        </div>
      </div>
      <div class="steps steps-3" v-if="currentStep == 2 && purchasingError">
        <img :src="require('@/assets/icons/warning.svg')">
        <h2>{{$t('license.payment.error')}}</h2>
        <p>{{$t('license.payment.unfortunateError')}}<br>{{$t('license.payment.engineerNotified')}}</p>
        <br />
        <p v-html="$t('license.payment.contactUs')"></p>
        <br />
      </div>
    </Content>

    <Sider :width="siderWidth" class="sider" v-show="currentStep == 0 || (selectedCourses.length > 0 && currentStep == 1)">
      <h1 class="cart-title">{{$t('license.shoppingCart')}}</h1>
      <Divider />
      <div class="cart-courses">
        <CourseCart v-for="course in selectedCourses" :key="course.code"
          :course="course" :entity="form.entity" :period="form.period" :vat="vat"
          @term-change="course.term = $event" />
      </div>
      <Divider  />
      <div class="subtotal total" v-if="selectedCourses.length > 0">
        <span>{{$t('license.total')}}</span>
        <span v-if="this.selectedCourses[0].pricing[this.form.entity].currency === 'nok'">
          {{$t('currency', {num: $options.filters.toCurrency(totalPriceEx, this.selectedCourses[0].pricing[this.form.entity].currency)})}}
        </span>
        <span v-else>
          {{this.selectedCourses[0].pricing[this.form.entity].currency.toUpperCase()}}
          {{$options.filters.toCurrency(totalPriceEx, this.selectedCourses[0].pricing[this.form.entity].currency)}}
        </span>
      </div>
      <template v-if="vatEnabled && selectedCourses.length > 0">
        <div class="subtotal total">
          <span style="font-weight: initial;">{{$t('license.ofVAT')}}</span>
          <span style="font-weight: initial;" v-if="this.selectedCourses[0].pricing[this.form.entity].currency === 'nok'">
            {{$t('currency', {num: $options.filters.toCurrency(vatPrice, this.selectedCourses[0].pricing[this.form.entity].currency)})}}
          </span>
          <span style="font-weight: initial;" v-else>
            {{this.selectedCourses[0].pricing[this.form.entity].currency.toUpperCase()}}
            {{$options.filters.toCurrency(vatPrice, this.selectedCourses[0].pricing[this.form.entity].currency)}}
        </span>
        </div>
      </template>

      <div class="vat-select">
        <div>{{$t('license.whereToUse')}}</div>
        <Dropdown trigger="click" @on-click="changeVat">
          <a href="javascript:void(0)">
            <span v-if="form.applyVat === 'true'">{{$t('license.useNorway')}}</span>
            <span v-else>{{$t('license.useInternational')}}</span>
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="true" :selected="form.applyVat === 'true'">{{$t('license.useNorway')}}</DropdownItem>
            <DropdownItem name="false" :selected="form.applyVat === 'false'">{{$t('license.useInternational')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Sider>
  </Layout>
</template>

<script>
import axios from 'axios';
import CourseCard from '../components/CourseCard.vue';
import CourseCart from '../components/CourseCart.vue';

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);

export default {
  name: 'License',
  created() {
    axios.get(process.env.VUE_APP_DCR_API + '/info', { withCredentials: false }).then(response => {
      if (response.data.country.code && response.data.country.code !== "NO") {
        this.form.country = response.data.country.code;
        this.changeVat("false");
      }
    });

    axios.get(process.env.VUE_APP_ROOT_API + '/api/stripe/products').then(response => {
      this.courses = response.data;

      // Restore session on cancel
      if (this.$route.query) {
        if (this.$route.query.result === "cancel") {
          axios.get(process.env.VUE_APP_ROOT_API + '/api/stripe/checkout/' + this.$route.query.session_id)
          .then(response => {
            const courses = response.data.items.map(i => {
              const course = this.courses.find(c => c.code === i.product);
              if (course) {
                course.term = i.interval;
                return course;
              }
              else
                return null;
            });

            this.selectedCourses = courses.filter(c => c);
            this.currentStep = 1;
            this.form.name = response.data.customer.name;
            this.form.email = response.data.customer.email;
            this.form.address = response.data.customer.metadata.address;
            this.form.city = response.data.customer.metadata.city;
            this.form.zip = response.data.customer.metadata.zip_code;
            this.form.country = response.data.customer.metadata.country;
            this.form.customer = response.data.customer;
          });
        }
      }
    });

    // Show successful purchase
    if (this.$route.query && this.$route.query.result === "success") {
      this.retrieveLicense(0);
    }

    window.addEventListener("hashchange", this.onHashChange);
  },
  destroyed() {
    window.removeEventListener("hashchange", this.onHashChange);
  },
  mounted() {

  },
  data() {
    return {
      currentStep: 0,
      posting: false,

      licenseEmail: null,
      licenseNumber: null,
      licensedCourses: [],
      purchasingError: false,

      formError: null,
      form: {
        type: "individual",
        entity: "individual",
        period: 'year',
        applyVat: 'true',
        name: '',
        email: '',
        ref: '',
        org: '',
        orgnr: '',
        address: '',
        zip: '',
        city: '',
        country: '',
        autoRenew: null,
        accepted: false,
        // For checkout session restore
        customer: null,
      },
      formRules: {
        name: [
          { required: true, message: this.$t('license.form.error.name'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('license.form.error.email'), trigger: 'blur' },
          { type: 'email', message: this.$t('license.form.error.email2'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('license.form.error.city'), trigger: 'blur' }
        ],
        zip: [
          { required: true, message: this.$t('license.form.error.zip'), trigger: 'blur' }
        ],
        autoRenew: [
          { required: true, message: this.$t('license.form.error.renew'), trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t('license.form.error.country'), trigger: 'change' }
        ],
      },

      selectedCourses: [],
      courses: []
    }
  },
  computed: {
    sortedCourses() {
      return [...this.courses].map(c => {
        switch (c.code) {
          case "prod_HxDk0EFphszt3T":
          case "prod_HxEr53qdEsIVZt":
            return [0, c];
          case "prod_HznQe906iKl2SK":
            return [1, c];
          default:
            return [2, c];
        }
      })
      .sort(([ai, ], [bi, ]) => ai - bi)
      .map(([, c]) => c);
    },
    siderWidth() {
      return window.innerWidth < 1200 ? 300 : 500;
    },
    subtotal() {
      if (this.form.type === 'individual') {
        let price = 0;
        for (let course of this.selectedCourses) {
          price += course.pricing[this.form.entity][course.term];
        }
        return price;
      } else if (this.selectedCourses.length > 0) {
        return this.totalPriceEx / this.selectedCourses.map(c => c.numStudents).reduce((a, b) => a + b);
      } else {
        return 0;
      }
    },
    vat() {
      return this.vatEnabled ? 1.25 : 1;
    },
    vatPrice() {
      if (this.form.type === 'individual') {
        return this.totalPriceEx - (this.totalPriceEx / this.vat);
      } else {
        return (this.totalPriceEx * this.vat) - this.totalPriceEx;
      }
    },
    vatEnabled() {
      return this.form.applyVat === 'true';
    },
    totalPriceEx() {
      if (this.form.type === 'individual') {
        return this.subtotal * this.vat;
      }

      let price = 0;
      for (let course of this.selectedCourses) {
        let subPrice = (course.pricing.institution * course.numStudents);
        // if (course.rebates.semester.validate(this.form.period))
        //     subPrice *= course.rebates.semester.intValue;
        if (course.rebates.institution.validate(course))
            subPrice *= course.rebates.institution.intValue;
        price += subPrice;
      }
      return price;
    },
    totalPrice() {
      return this.totalPriceEx + this.vatPrice;
    }
  },
  methods: {
    prevStep() {
      if (this.$route.query && this.$route.query.result === "cancel") {
        this.currentStep -= 1;
        window.history.replaceState({}, "", "?");
      } else {
        window.history.back();
      }
    },
    nextStep() {
      if (this.currentStep === 0 && this.selectedCourses.length === 0) return;
      this.currentStep += 1;
      window.history.pushState({}, "", `#${this.currentStep}`);
    },
    onHashChange(e) {
      if (this.currentStep === 1) {
        e.preventDefault();
        this.currentStep -= 1;
        return false;
      } else {
        window.location.hash = '';
      }
    },
    changeVat(vat) {
      this.form.applyVat = vat;
      if (vat === "true") {
        this.form.entity = "individual";
      } else {
        switch (this.form.country) {
          case "IN":
            this.form.entity = "india"; break;
          default:
            this.form.entity = "international"; break;
        }
      }
      this.selectedCourses = this.selectedCourses.filter(c => c.pricing[this.form.entity].year !== 0);
    },
    selectCourse(checked, course) {
      if (checked) {
        if (!this.selectedCourses.find(c => c.code === course.code)) {
          this.selectedCourses.push(course);
        }
      } else {
        this.selectedCourses = this.selectedCourses.filter(c => c.code !== course.code);
      }

      const findLit = c => c.code === "prod_EUF9Qb1fQ4oFho" || c.code === "prod_EVNC5sex7zg26Z";
      const findNum = c => c.code === "prod_EUFbJQteMCwBUq" || c.code === "prod_EVNCJFw9igqToc";
      const findLitNum = c => c.code === "prod_HxDk0EFphszt3T" || c.code === "prod_HxEr53qdEsIVZt";

      // If both nor lit and num selected, change to litnum package
      if (this.selectedCourses.find(findLit) && this.selectedCourses.find(findNum)) {
        this.selectedCourses.push(this.courses.find(findLitNum));
      }

      // // If Nor litnum package selected (will also fix stuff from previous `if` when both lit/num was selected)
      if (this.selectedCourses.find(findLitNum)) {
        this.courses.find(findLit).active = false;
        this.courses.find(findNum).active = false;
        this.selectedCourses = this.selectedCourses.filter(c =>
          !["prod_EUF9Qb1fQ4oFho", "prod_EVNC5sex7zg26Z", "prod_EUFbJQteMCwBUq", "prod_EVNCJFw9igqToc"].includes(c.code));
      } else {
        this.courses.find(findLit).active = true;
        this.courses.find(findNum).active = true;
      }
    },
    submitForm() {
      this.$refs.form.validate().then(valid => {
        if (!valid) return;

        this.$Spin.show();
        this.posting = true;
        this.purchasingError = false;

        axios.post(process.env.VUE_APP_ROOT_API + '/api/stripe/checkout', {
          ...this.form,
          applyVat: this.form.applyVat === 'true',
          courses: this.selectedCourses,
          locale: this.$i18n.locale,
          return_url: `${location.protocol}//${location.host}${location.pathname}`,
        })
        .then(response => {
          stripe.redirectToCheckout({sessionId: response.data.session.id}).then(result => {
            this.$Spin.hide();
            this.posting = false;
            this.formError = result.error.message;
          });
        }).catch(error => {
          this.$Spin.hide();
          this.posting = false;
          if (error.response) {
            if (error.response.status >= 500) {
              this.formError = "Unknown error occured. Please try again later";
            } else {
              this.formError = error.response.data.message;
            }
          } else {
            if (error.message)
              this.formError = error.message;
            else
              this.formError = "Unknown error occured. Please try again later";
          }
        });
      });
    },
    retrieveLicense(tries) {
      if (tries > 10) {
        this.showPurchaseError();
        return;
      }

      this.$Spin.show();
      axios.get(process.env.VUE_APP_ROOT_API + '/api/stripe/checkout/' + this.$route.query.session_id)
      .then(response => {
        if (response.data.license) {
          this.$Spin.hide();
          this.licenseNumber = response.data.license.number;
          this.licenseEmail = response.data.license.email;
          this.purchasingError = false;
          this.currentStep = 2;
          this.licensedCourses = response.data.items;
        } else {
          setTimeout(() => this.retrieveLicense(tries + 1), 2000);
        }
      }).catch(() => {
        setTimeout(() => this.retrieveLicense(tries + 1), 2000);
      });
    },
    showPurchaseError() {
      this.$Spin.hide();
      this.purchasingError = true;
      this.currentStep = 2;
    }
  },
  components: {
    CourseCard,
    CourseCart
  }
}
</script>

<style lang="scss">
.sider {
  min-height: calc(100vh - 64px);
  background-color: #e9edf2 !important;
  padding: 50px 50px;
}
.ivu-steps {
  padding: 0 100px;

  @media only screen and (max-width: 1400px) {
    margin-left: 25px;
  }
}
.ivu-steps .ivu-steps-head,
.ivu-steps .ivu-steps-title {
  background: transparent !important;
}
.ivu-steps .ivu-steps-title {
  margin-top: -4px;
}
.ivu-steps .ivu-steps-content {
  margin-top: -10px;
}
.ivu-steps-item:first-child .ivu-steps-content {
  padding-left: 35px;
}
.ivu-divider {
  background-color: #cbcbcb !important;
}
.ivu-form-item-required .ivu-form-item-label::before {
  content: '' !important;
}
.ivu-alert-info {
  width: 85%;
  margin: 0 auto 20px auto;
  text-align: left;
}
.steps {
  text-align: center;
  padding-top: 35px;
}
.prev-button {
  display: block;
  float: left;
  margin-left: 8%;
  margin-top: 50px;
}
.next-button {
  display: block;
  float: right;
  margin-right: 8%;
  margin-top: 50px;
}
.StripeElement {
  padding-top: 7px !important;
}
.steps-1 {
  .vat-select {
    margin-bottom: 20px;

    div {
      margin-bottom: 5px;
    }
  }
}
.steps-2 {
  text-align: center;

  form {
    text-align: left;
    width: 66%;
    margin: 35px auto;
  }

  .errors {
    color: #ed4014;
    font-size: 14px;
  }
}
.steps-3 {
  img {
    margin-top: 25px;
    max-width: 180px;
  }
  h2 {
    margin-top: 25px;
  }
}
h1 .ivu-radio-group {
  float: right;
}
.subtotal {
  font-size: medium;
  margin-top: 10px;

  & > span:last-child {
    float: right;
  }

  span .ivu-radio-group {
    margin-top: -10px;
    margin-bottom: 15px;
  }
}
.total {
  font-weight: 500;

  span:last-child {
    font-weight: 700;
  }
}

.vat-select {
  position: absolute;
  top: 42px;
  right: 30px;
  font-size: 14px;

  @media only screen and (max-width: 1200px) {
    top: 6px;
  }
}
</style>

<style scoped lang="scss">
.buy-license {
  position: relative;
  min-width: 700px;
  background: #f5f7f9;

  padding: 50px 20px;

  @include respond-to(large) {
    margin-left: 25px;
  }

  .institutions {
    font-size: 16px;
    margin: 30px 0 -15px 50px;
  }

  .download-buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 25px;

    button {
      height: 64px;
    }

    .android-button {
      display: inline-block;
      background: url('~@/assets/google-play-badge.png');
      background-size: cover;
      height: 64px;
      width: 215px;
      margin-left: 10px;
    }

    .ios-button {
      display: inline-block;
      background: url('~@/assets/appstore_250px.png');
      background-size: cover;
      height: 64px;
      width: 192px;
      margin-left: 10px;
    }
  }
}
@include respond-to(large) {
  .steps.steps-1, .steps.steps-2, .steps.steps-3 {
    margin-left: -50px;
  }
  .steps-3 {
    font-size: 16px;
  }
}
</style>